export const PROVIDER = {
  LICENSE: 'license',
  RESUME: 'resume',
  DOCUMENTS: 'documents',
  SPECIALITY: 'speciality',
};

export const SENDGRID_CONTRACT_LIST = {
  ALL_PATIENTS: '6a86af51-68fc-4ecd-9ba0-bec2678673d2',
  ALL_DOCTORS: 'bb51e35f-5d78-47d0-b858-d1ec36005e1f',
  BAYER_AND_JDE: '06b8b741-9255-4e2b-bb86-be9a72ac63f2',
  FREE_TRIAL: 'b1230b55-d2ab-4248-a8fc-5de2c70d1523',
};

export const MEETING_PANEL = {
  KICK: 'kick',
  LEAVE: 'leave',
};
export const StatusCode = Object.freeze({
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  TOO_MANY_REQUESTS: 429,
});

export const COMMUNITY_FACEBOOK_LINK = 'https://www.facebook.com/getvivianlab';

export const DEFAULT_PRODUCT_NAME =
  'Βασικό ποσό: €100, ΦΠΑ (24%): €24, Συνολικό ποσό (συμπεριλαμβανομένου ΦΠΑ): €124';

export const USERTYPES = {
  INDIVIDUAL: 'individual',
  COMPANY: 'company',
};

export const recipeOptions = {
  el: {
    Recipes: 'Συνταγές',
    'Nutrition plans': 'Πλάνα διατροφής',
    'Mindfulness techniques': 'Τεχνικές Mindfulness',
    Exercise: 'Άσκηση',
  },
  de: {
    Recipes: 'Rezepte',
    'Nutrition plans': 'Ernährungspläne',
    'Mindfulness techniques': 'Achtsamkeitstechniken',
    Exercise: 'Übung',
  },
  en: {
    Recipes: 'Recipes',
    'Nutrition plans': 'Nutrition plans',
    'Mindfulness techniques': 'Mindfulness techniques',
    Exercise: 'Exercise',
  },
};

export const getTranslatedRecipe = (key, ln) => {
  return recipeOptions[ln]?.[key] || key; // Return the translated word or default to the key if not found
};

export const EnvBool = {
  TRUE: 'true',
  FALSE: 'false',
};

export const RenderChatFeedKey = Object.freeze({
  STREAMING: 'streaming',
  AI: 'ai',
  YOUTUBE: 'youtube',
  DEFAULT: 'default',
});

export const CUSTOMER_TYPES = Object.freeze({
  CORPORTATE: 'corporate',
  TRIAL: 'trial',
});

export const MODULES = Object.freeze({
  MENOPAUSE: 'Menopause',
  FAMILY_PROGRAM: 'Family Program',
});

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

export const recurringIntervalMap = {
  en: {
    month: 'month',
    year: 'year',
  },
  de: {
    month: 'Monat',
    year: 'Jahr',
  },
  el: {
    month: 'μήνα',
    year: 'χρόνο',
  },
};

export const COOKIE_OPTIONS = { expires: 1, secure: true, sameSite: 'Strict' };

export const DOCTOR_PROVIDER_ROUTE = '/doctors';

export const freeTrialOption = {
  id: 'free_trial',
  recurring_interval: '7_day',
  unit_amount: 0,
  currency: 'eur',
};

export const subscriptionOptions = {
  trial: '7_day',
  year: 'year',
  month: 'month',
};

export const BASE_COLORS = [
  '#a57e69',
  '#739b72',
  '#EE8B51',
  '#d187bf',
  '#FAD5C1',
  '#b5898b',
  '#FEF4EB',
  '#FCA311',
  '#B0B0B0',
  '#8885ab',
  '#959375',
  '#d5717b',
];
export const FavoriteStateChange = {
  Favorited: 'favorited',
  Unfavorited: 'unfavorited',
};

export const FavoriteType = {
  Video: 'video',
  Article: 'article',
};

export const FavoriteFilterType = [
  { value: 'all', label: 'All' },
  { value: 'video', label: 'Video' },
  { value: 'article', label: 'Article' },
];

export const CATEGORY_FILTERS = [
  'Mindfulness Exercises',
  'Nutrition Plans',
  'Recipes',
  'Hypnotherapy Exercises',
  'Sex Tips',
  'Workouts',
  'Pelvic Floor Therapy',
  'Other',
];

// Map labels → i18n keys
// Map labels (EN + EL + DE + AR) → i18n keys
export const categoryI18nKeys = {
  // English
  'Mindfulness Exercises': 'SectionHandleSymptom.categories.mindfulness',
  'Nutrition Plans': 'SectionHandleSymptom.categories.nutrition',
  Recipes: 'SectionHandleSymptom.categories.recipes',
  'Hypnotherapy Exercises': 'SectionHandleSymptom.categories.hypnotherapy',
  'Sex Tips': 'SectionHandleSymptom.categories.sexTips',
  'Pelvic Floor Therapy': 'SectionHandleSymptom.categories.pelvicFloor',
  Workouts: 'SectionHandleSymptom.categories.workouts',
  Other: 'SectionHandleSymptom.categories.other',

  // Greek
  'Ασκήσεις Ενσυνειδητότητας': 'SectionHandleSymptom.categories.mindfulness',
  'Διατροφικά Πλάνα': 'SectionHandleSymptom.categories.nutrition',
  'Συνταγές': 'SectionHandleSymptom.categories.recipes',
  'Ασκήσεις Υπνοθεραπείας': 'SectionHandleSymptom.categories.hypnotherapy',
  'Συμβουλές για τη Σεξουαλική Υγεία': 'SectionHandleSymptom.categories.sexTips',
  'Θεραπεία Πυελικού Εδάφους': 'SectionHandleSymptom.categories.pelvicFloor',
  'Προπονήσεις': 'SectionHandleSymptom.categories.workouts',
  'Άλλο': 'SectionHandleSymptom.categories.other',

  // German
  Achtsamkeitsübungen: 'SectionHandleSymptom.categories.mindfulness',
  Ernährungspläne: 'SectionHandleSymptom.categories.nutrition',
  Rezepte: 'SectionHandleSymptom.categories.recipes',
  'Hypnotherapie-Übungen': 'SectionHandleSymptom.categories.hypnotherapy',
  'Sex-Tipps': 'SectionHandleSymptom.categories.sexTips',
  Beckenbodentherapie: 'SectionHandleSymptom.categories.pelvicFloor',
  Trainingseinheiten: 'SectionHandleSymptom.categories.workouts',
  Sonstiges: 'SectionHandleSymptom.categories.other',

  // Arabic
  'تمارين اليقظة الذهنية': 'SectionHandleSymptom.categories.mindfulness',
  'خطط التغذية': 'SectionHandleSymptom.categories.nutrition',
  'وصفات': 'SectionHandleSymptom.categories.recipes',
  'تمارين العلاج بالتنويم المغناطيسي': 'SectionHandleSymptom.categories.hypnotherapy',
  'نصائح للصحة الجنسية': 'SectionHandleSymptom.categories.sexTips',
  'علاج قاع الحوض': 'SectionHandleSymptom.categories.pelvicFloor',
  'تمارين رياضية': 'SectionHandleSymptom.categories.workouts',
  'أخرى': 'SectionHandleSymptom.categories.other',
};

// Build array of objects for mapping in UI
export const CATEGORY_OPTIONS = CATEGORY_FILTERS.map(label => ({
  label, // raw text
  i18nKey: categoryI18nKeys[label] || label, // i18n key or fallback
}));

// Wellness start
export const PROGRAM_STATUS = {
  ENROLLED: 'enrolled',
  COMPLETED: 'completed',
  NONE: 'none',
};

export const TAB_TYPES = {
  ALL: 'all',
  ENROLLED: 'enrolled',
  COMPLETED: 'completed',
};

const normalizeWellnessLocale = (locale = 'en') => String(locale || 'en').toLowerCase();

const wellnessRatingLabels = {
  en: ['Never', 'Rarely', 'Sometimes', 'Often', 'Always'],
  el: ['Ποτέ', 'Σπάνια', 'Μερικές φορές', 'Συχνά', 'Πάντα'],
  de: ['Nie', 'Selten', 'Manchmal', 'Oft', 'Immer'],
  ar: ['أبدًا', 'نادرًا', 'أحيانًا', 'غالبًا', 'دائمًا'],
};

const wellnessSelfCheckQuestions = {
  en: [
    'How has this program affected your overall libido?',
    'Did you notice improvements in body confidence after completing the tasks?',
    'What emotions arose during the self-touch exercises?',
    'How did the relaxation practices impact your sense of intimacy?',
    'Did avoiding certain foods help stabilize your energy levels?',
    'How did the gratitude affirmations influence your mindset?',
    'What changes did you observe in your connection with your body?',
    'Would you recommend this program to others experiencing similar issues?',
    'How has your stress level changed after following the breathing practices?',
    'Did the abdominal massage relieve any physical discomfort?',
  ],
  el: [
    'Πώς έχει επηρεάσει αυτό το πρόγραμμα τη συνολική σου λίμπιντο;',
    'Παρατήρησες βελτίωση στην αυτοπεποίθησή σου για το σώμα σου μετά την ολοκλήρωση των ασκήσεων;',
    'Ποια συναισθήματα προέκυψαν κατά τις ασκήσεις αυτοεπαφής;',
    'Πώς επηρέασαν οι πρακτικές χαλάρωσης την αίσθηση οικειότητας που νιώθεις;',
    'Βοήθησε η αποφυγή συγκεκριμένων τροφών να σταθεροποιηθούν τα επίπεδα ενέργειάς σου;',
    'Πώς επηρέασαν τη νοοτροπία σου οι ασκήσεις ευγνωμοσύνης;',
    'Τι αλλαγές παρατήρησες στη σχέση σου με το σώμα σου;',
    'Θα πρότεινες αυτό το πρόγραμμα σε άλλους ανθρώπους με παρόμοιες δυσκολίες;',
    'Πώς έχει αλλάξει το επίπεδο του στρες σου ακολουθώντας τις ασκήσεις αναπνοής;',
    'Ανακούφισε το κοιλιακό μασάζ κάποια σωματική ενόχληση;',
  ],
  de: [
    'Wie hat dieses Programm Ihre Libido insgesamt beeinflusst?',
    'Haben Sie nach Abschluss der Aufgaben Verbesserungen in Ihrem Körpergefühl bemerkt?',
    'Welche Gefühle sind während der Übungen zur Selbstberührung aufgekommen?',
    'Wie haben sich die Entspannungsübungen auf Ihr Empfinden von Intimität ausgewirkt?',
    'Hat der Verzicht auf bestimmte Lebensmittel geholfen, Ihr Energieniveau zu stabilisieren?',
    'Wie haben die Dankbarkeitsaffirmationen Ihre innere Haltung beeinflusst?',
    'Welche Veränderungen haben Sie in Ihrer Verbindung zu Ihrem Körper bemerkt?',
    'Würden Sie dieses Programm anderen Menschen mit ähnlichen Beschwerden empfehlen?',
    'Wie hat sich Ihr Stresslevel verändert, nachdem Sie die Atemübungen durchgeführt haben?',
    'Hat die Bauchmassage körperliche Beschwerden gelindert?',
  ],
  ar: [
    'كيف أثّر هذا البرنامج في رغبتك الجنسية بشكل عام؟',
    'هل لاحظتِ تحسنًا في ثقتك بجسدك بعد إكمال المهام؟',
    'ما المشاعر التي ظهرت أثناء تمارين اللمس الذاتي؟',
    'كيف أثّرت ممارسات الاسترخاء في إحساسك بالحميمية؟',
    'هل ساعدك تجنّب بعض الأطعمة على استقرار مستوى الطاقة لديك؟',
    'كيف أثّرت عبارات الامتنان في طريقة تفكيرك؟',
    'ما التغييرات التي لاحظتِها في علاقتك بجسدك؟',
    'هل تنصحين بهذا البرنامج لغيرك ممن يمرّون بتجارب مشابهة؟',
    'كيف تغيّر مستوى التوتر لديك بعد اتباع تمارين التنفس؟',
    'هل خفّف تدليك البطن أي انزعاج جسدي؟',
  ],
};

const getWellnessLocaleKey = locale => {
  const normalizedLocale = normalizeWellnessLocale(locale);
  if (normalizedLocale.startsWith('ar')) return 'ar';
  if (normalizedLocale.startsWith('el')) return 'el';
  if (normalizedLocale.startsWith('de')) return 'de';
  return 'en';
};

export const getWellnessRatings = (locale = 'en') => {
  const labels = wellnessRatingLabels[getWellnessLocaleKey(locale)] || wellnessRatingLabels.en;

  return labels.map((label, index) => ({
    value: String(index),
    label,
  }));
};

export const getStaticWellnessSelfCheck = (locale = 'en') => {
  return (
    wellnessSelfCheckQuestions[getWellnessLocaleKey(locale)] || wellnessSelfCheckQuestions.en
  );
};
// Wellness end
export const TOPBAR_GUIDE_OPTIONS = Object.freeze({
  Menopause: 'Menopause & Hormonal Balance',
  Nutrition: 'Nutrition: Tips & Recipes',
  Psychology: 'Psychology & Hypnotherapy',
  Fertility: 'Fertility',
});

export const MIXPANEL_EVENT_PARENT = Object.freeze({
  SYMPTOMS: 'symptoms',
  SESSIONS: 'sessions',
  QUICK_RESOURCES: 'quick_resources',
  PROGRAMS: 'programs',
  VIDEOS: 'videos',
  ARTICLES: 'articles',
  LOGIN: 'login',
  LOGOUT: 'logout',
  CONTACT: 'contact',
  REGISTER: 'register',
  FAMILY_PROGRAM: 'family_program',
  CHAT_BOT: 'chatbot',
  CARE_HUB: 'care_hub',
  TRACKERS: 'trackers',
});

export const MIXPANEL_PAGE_NAME = Object.freeze({
  FamilyProgramPage: 'FamilyProgramPage',
  ProductTreatmentsPage: 'ProductTreatmentsPage',
  AIConsultPage: 'AIConsultPage',
});

export const MIXPANEL_EVENTS = Object.freeze({
  SYMPTOM_CLICKED: 'symptom_clicked',
  SYMPTOM_FILTER_APPLIED: 'symptom_filter_applied',
  SYMPTOM_FILTER_COMBINATION: 'symptom_filter_combination',
  ALL_SESSIONS_CLICKED: 'all_sessions_clicked',
  SESSION_CLICKED: 'session_clicked',
  EVENTS_NAV_CLICKED: 'events_nav_clicked',
  EXPLORE_SESSION_CLICKED: 'explore_sessions_clicked',
  SESSION_CLICKED_FROM_SYMPTOMS: 'session_clicked_from_symptoms',
  SESSIONS_FILTER_APPLIED: 'sessions_filter_applied',
  SESSION_DATE_SELECTED: 'session_date_selected',
  SESSIONS_FILTER_COMBINATION: 'sessions_filter_combination',
  SESSION_JOIN_CLICKED: 'session_join_clicked',
  QUICK_RESOURCE_CLICKED: 'quick_resource_clicked',
  PROGRAM_CLICKED: 'program_clicked',
  ALL_PROGRAMS_CLICKED: 'all_programs_clicked',
  PROGRAM_ENROLLED: 'program_enrolled',
  PROGRAM_RE_ENROLLED: 'program_reenrolled',
  PROGRAM_UN_ENROLLED: 'program_unenrolled',
  WP_TASK_OPENED: 'wptask_opened',
  WP_TASK_COMPLETED: 'wptask_completed',
  WP_TASK_ARTICLE_OPENED: 'wptask_article_opened',
  WP_TASK_VIDEO_WATCHED: 'wptask_video_watched',
  SELF_CHECK_OPENED: 'selfcheck_opened',
  SELF_CHECK_COMPLETED: 'selfcheck_completed',
  MODULE_CLICKED: 'module_clicked',
  VIDEO_CLICKED: 'video_clicked',
  VIDEO_WATCHED: 'video_watched',
  VIDEO_FAVOURITED: 'video_favourited',
  VIDEO_UNFAVOURITED: 'video_unfavourited',
  ARTICLE_CATEGORY_CLICKED: 'article_category_clicked',
  ARTICLE_CATEGORY_NAV_CLICKED: 'article_category_nav_clicked',
  ARTICLE_FAVOURITED: 'article_favourited',
  ARTICLE_UNFAVOURITED: 'article_unfavourited',
  RELATED_ARTICLE_CLICKED: 'related_article_clicked',
  ARTICLE_CLICKED: 'article_clicked',
  CONTACT_INFO_BUTTON: 'contact_info_button',
  CONTACT_FOOTER: 'contact_footer',
  CONTACT_SUBMITTED: 'contact_submitted',
  LOGOUT_COMPLETED: 'logout_completed',
  LOGIN_OPENED: 'login_opened',
  LOGIN_COMPLETED: 'login_completed',
  SIGNUP_OPENED: 'signup_opened',
  SIGNUP_COMPLETED: 'signup_completed',
  START_FREE_TRIAL: 'start_free_trial',
  PURCHASE_COMPLETED: 'purchase_completed',
  FAMILY_MODULE_CLICKED: 'family_module_clicked',
  FAMILY_CARD_CLICKED: 'family_card_clicked',
  FAMILY_NAV_CLICKED: 'family_nav_clicked',
  MESSAGE_SENT: 'message_sent',
  SUGGESTED_PROMPT_CLICKED: 'suggested_prompt_clicked',
  AI_OPENED: 'ai_opened',
  CARE_HUB_ENTERED: 'care_hub_entered',
  PRODUCT_CLICKED: 'product_clicked',
  PARTNER_URL_CLICKED: 'partner_url_clicked',
  SYMPTOM_TRACKING_OPENED: 'symptom_tracking_opened',
  SYMPTOM_SAVED: 'symptoms_saved',
  SYMPTOM_ANALYTICS: 'symptom_analytics',
  MOOD_TRACKING_OPENED: 'mood_tracking_opened',
  MOOD_SELECTED: 'mood_selected',
  MOOD_CLEARED: 'mood_cleared',
  MOOD_ANALYTICS: 'mood_analytics',
  HABIT_TRACKING_OPENED: 'habit_tracking_opened',
  HABIT_CHECKED: 'habit_checked',
  HABIT_UNCHECKED: 'habit_unchecked',
  HABIT_ANALYTICS: 'habit_analytics',
  REGISTER_WITH_COUPON: 'register_with_coupon',
  COUPON_FREE_SIGNUP: 'coupon_free_signup',
  REQUIRES_PAYMENT: 'requires_payment',
  ONBOARDING_STAGE: 'onboarding_stage',
  ONBOARDING_SYMPTOMS: 'onboarding_symptoms',
  ONBOARDING_GOALS: 'onboarding_goals',
  SUBSCRIPTION_SELECTED: 'subscription_selected',
});

export const topicMap = {
  nutrition: 'nutrition',
  menopause: 'mhb',
  psychology: 'ph',
  fertility: 'fertility',
};

export const itemListCardPageName = {
  favorites: 'FavoritesPage',
  symptom: 'SymptomPage',
};

export const moodSymptomHabitTriggerType = {
  pill: 'pill click',
  custom_date_selector: 'custom date selector',
};

export const consentsConfig = [
  {
    fieldName: 'newsletterConsent',
    labelId: 'PersonalSettingsForm.newsletterLabel',
    descriptionKey: 'newsletter',
  },
  {
    fieldName: 'aiUsageConsent',
    labelId: 'PersonalSettingsForm.aiUsageLabel',
    descriptionKey: 'aiUsage',
  },
  {
    fieldName: 'symptomTrackingConsent',
    labelId: 'PersonalSettingsForm.symptomTrackingLabel',
    descriptionKey: 'symptomTrackingConsent',
  },
];

export const BIO_PAGE_LINK = 'https://bioiatriki.gr/paketa-emminopafsis-vivian-lab/';
